import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./PasswordInputValidation.css";

const PasswordInputValidation = ({
  name,
  placeholder = "New Password",
  value,
  onChange,
  className = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setPasswordRequirements({
      minLength: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[!@#$%&*]/.test(password),
    });
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`password-input-wrapper ${className}`}>
      <div className="new-password-container">
        <input
          name={name}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={handlePasswordChange}
          required
        />
        <button
          type="button"
          className="new-password-toggle"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </button>
      </div>
      <div className="new-password-requirements">
        Password must be at least 8 characters long and contain:
        <ul>
          <li
            className={
              passwordRequirements.minLength
                ? "requirement-met"
                : "requirement-unmet"
            }
          >
            {passwordRequirements.minLength ? "✓" : "✗"} At least 8 characters
          </li>
          <li
            className={
              passwordRequirements.hasUpperCase
                ? "requirement-met"
                : "requirement-unmet"
            }
          >
            {passwordRequirements.hasUpperCase ? "✓" : "✗"} Uppercase letters
          </li>
          <li
            className={
              passwordRequirements.hasLowerCase
                ? "requirement-met"
                : "requirement-unmet"
            }
          >
            {passwordRequirements.hasLowerCase ? "✓" : "✗"} Lowercase letters
          </li>
          <li
            className={
              passwordRequirements.hasNumber
                ? "requirement-met"
                : "requirement-unmet"
            }
          >
            {passwordRequirements.hasNumber ? "✓" : "✗"} Numbers
          </li>
          <li
            className={
              passwordRequirements.hasSpecialChar
                ? "requirement-met"
                : "requirement-unmet"
            }
          >
            {passwordRequirements.hasSpecialChar ? "✓" : "✗"} Special characters
            (e.g., !, @, #, $, %, &, *)
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PasswordInputValidation;
